// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "root-3Z690";
var _5 = "root_old-yhTar";
var _6 = "root_disabled-1FBqh";
var _7 = "root_fareLock-3xi1X";
var _8 = "root_refund-K44Tv";
var _9 = "root_upgrade-UfB8J";
var _a = "root_note-1-eXn";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "root", _5 as "root_old", _6 as "root_disabled", _7 as "root_fareLock", _8 as "root_refund", _9 as "root_upgrade", _a as "root_note" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "root": _4, "root_old": _5, "root_disabled": _6, "root_fareLock": _7, "root_refund": _8, "root_upgrade": _9, "root_note": _a }
